import axios from '@/utils/request' // axios

// 证件照 - 客人上传 - 获取订单的身份验证信息
export const vertifyInfo = (params = {}) => axios.get('/openpms/identification/identity/verify/method/list', { params }).then(res => res.data)

// 证件照 - 客人上传 - 验证身份信息
export const authenticate = (params = {}) => axios.post('/openpms/identification/identity/verify', params).then(res => res.data)

// 客户证件-详情
export const result = (params = {}) => axios.get('/openpms/identification/get', { params }).then(res => res.data)

// 证件照 - 客人上传 - 保存证件信息
export const save = (params = {}) => axios.post('/openpms/identification/save', params).then(res => res.data)

// 身份验证方式列表
export const methodList = (params = {}) => axios.get('/openpms/identification/identity/verify/method/list', { params }).then(res => res.data)

// 客户证件列表
export const list = (params = {}) => axios.get('/openpms/identification/list', { params }).then(res => res.data)

// 证件照 - 客人上传 - 更新证件信息
export const update = (params = {}) => axios.post('/openpms/identification/update', params).then(res => res.data)
